import React from 'react'

const LoadingComponent = () => <div>Loading...</div>

export default LoadingComponent
